const initialState: any = {};

/**
 * TrainingStatusReducer: Reducer to manage the training status.
 * @param {any} state - The current state of the training status.
 * @param {any} action - The action to be processed.
 * @returns {any} - The updated state based on the action type.
 */

const TrainingStatusReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case "SET_TRAINING_STATUS":
      return action.payload;
      break;
    default:
      return state;
  }
};

export default TrainingStatusReducer;
